module.exports = __webpack_public_path__ + "img/indu_active_3.0452be5d.png";